var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDepartment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "groups_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3118",
    "data-name": "Rectangle 3118",
    width: 22,
    height: 22,
    fill: "none"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1885",
    "data-name": "Group 1885",
    transform: "translate(0 5.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_8272",
    "data-name": "Path 8272",
    d: "M11,12.188a9.727,9.727,0,0,1,3.887.825,2.736,2.736,0,0,1,1.613,2.5v.568a.919.919,0,0,1-.917.917H6.417a.919.919,0,0,1-.917-.917v-.559a2.716,2.716,0,0,1,1.613-2.5A9.57,9.57,0,0,1,11,12.188Zm-7.333.229a1.833,1.833,0,1,0-1.833-1.833A1.839,1.839,0,0,0,3.667,12.417ZM4.7,13.425a6.4,6.4,0,0,0-1.036-.092,6.371,6.371,0,0,0-2.548.532A1.843,1.843,0,0,0,0,15.561v.523A.919.919,0,0,0,.917,17H4.125V15.524A4.124,4.124,0,0,1,4.7,13.425Zm13.631-1.008A1.833,1.833,0,1,0,16.5,10.583,1.839,1.839,0,0,0,18.333,12.417ZM22,15.561a1.843,1.843,0,0,0-1.118-1.7,6.232,6.232,0,0,0-3.584-.44,4.124,4.124,0,0,1,.577,2.1V17h3.208A.919.919,0,0,0,22,16.083ZM11,6A2.75,2.75,0,1,1,8.25,8.75,2.746,2.746,0,0,1,11,6Z",
    transform: "translate(0 -6)",
    fill: "#141414"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartment);
export default __webpack_public_path__ + "static/media/department.06fb5bb9c47b68102545ab903f38490b.svg";
export { ForwardRef as ReactComponent };